module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-SemiBold.8ae6c9c0.eot";